import {
    Button,
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from '@quadminds/mindkit';

import { useReactTable } from '@tanstack/react-table';
import { Eye } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileItem } from '../../../../types/File/File.types';

interface ColumnSelectorProps {
    readonly table: ReturnType<typeof useReactTable<FileItem>>;
}

export function ColumnSelector({ table }: ColumnSelectorProps) {
    const { t } = useTranslation();

    const hiddenColumns = new Set(['select', 'name', 'actions']);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="ml-auto">
                    <Eye className="h-4 w-4 mr-2" />
                    {t('knowledgeManager.table.selectColumns')}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {table
                    .getAllColumns()
                    .filter(
                        (column: { id: string; getCanHide: () => boolean }) =>
                            !hiddenColumns.has(column.id) && column.getCanHide(),
                    )
                    .map(
                        (column: {
                            id: React.Key | null | undefined;
                            getIsVisible: () => string | boolean | undefined;
                            toggleVisibility: (arg0: boolean) => void;
                        }) => {
                            return (
                                <DropdownMenuCheckboxItem
                                    key={column.id}
                                    className="capitalize"
                                    checked={!!column.getIsVisible()}
                                    onCheckedChange={(value) => column.toggleVisibility(!!value)}
                                >
                                    {column.id === 'name' && 'Nombre'}
                                    {column.id === 'summary' && 'Resumen'}
                                    {column.id === 'comments' && 'Comentarios'}
                                    {column.id === 'active' && 'Activo'}
                                    {column.id === 'status' && 'Estado'}
                                    {column.id === 'modifiedAt' && 'Última modificación'}
                                </DropdownMenuCheckboxItem>
                            );
                        },
                    )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default ColumnSelector;
